function setCookie(key, value, expiryDays) {
    var expires = new Date();
    expires.setTime(expires.getTime() + (expiryDays * 24 * 60 * 60 * 1000));
    document.cookie = encodeURIComponent(key) + '=' + encodeURIComponent(value) + 
                      ';expires=' + expires.toUTCString() + 
                      ';path=/'; // Adding path ensures cookie is available site-wide
}

function getCookie(key) {
    var cookies = document.cookie.split('; ');
    for (var i = 0; i < cookies.length; i++) {
        var parts = cookies[i].split('=');
        if (decodeURIComponent(parts[0]) === key) {
            return decodeURIComponent(parts[1]);
        }
    }
    return null;
}

function eraseCookie(key) {
    document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
}


const imageUrlMap_new = {
  FR: 'https://i.ibb.co/cts9dYH/Daily-Compress-French.png',
  BE: 'https://i.ibb.co/wJ4RzpM/Daily-Compress-Belgium.png',
  NL: 'https://i.ibb.co/bLVWSHK/Daily-Compress-Netherlands.png',
  DE: "https://i.ibb.co/9r16Fnc/Betaalmethoden-Duitsland.png",
  AT: "https://i.ibb.co/9r16Fnc/Betaalmethoden-Duitsland.png",
  SE: "https://cdn.shopify.com/s/files/1/0783/0994/9777/t/8/assets/Payment_SE.webp?v=1727766515",
  FI: "https://cdn.shopify.com/s/files/1/0783/0994/9777/t/8/assets/Payment_SE.webp?v=1727766515",
  NO: "https://cdn.shopify.com/s/files/1/0783/0994/9777/t/8/assets/Payment_SE.webp?v=1727766515",
  DK: "https://cdn.shopify.com/s/files/1/0783/0994/9777/t/8/assets/Payment_SE.webp?v=1727766515"
};

let isFetching_new = false; // Flag to prevent multiple fetch requests
let imageUpdated_new = false; // Flag to ensure the image source is updated only once

// Function to fetch the country code and update image source
function updateTrustBadgeImagenew() {
  if (isFetching_new) return; // Prevent multiple fetches if one is already in progress
  isFetching_new = true;

  // Fetch the user's location
  
  var country__code = getCookie('changeCount');
 
  if (country__code == null){

    fetch('https://api.ipgeolocation.io/v3/ipgeo?apiKey=fe01f8e73b3f4956867bfb5bb8c65eea')
        .then(response => response.json())
        .then(data => {
        console.log('Location data:', data); // Log the location data for debugging
        
        const countryCode = data.location.country_code2;
        setCookie('changeCount', data.location.country_code2, 7);
        console.log(countryCode);
        const imageUrl = imageUrlMap_new[countryCode];

        if (imageUrl) {
            // Find the image tag with class 'upcart-trust-badge-image'
            //const imageElement = document.getElementsByClassName('upcart-trust-badge-image');
            var container_new = document.querySelector('#upCart');
            const imageElement = container_new.shadowRoot.querySelector(".upcart-trust-badge-image");
            
            if (imageElement) {
            // Update the image src based on country code
            imageElement.src = imageUrl;
            imageElement.style = 'display:block';
            imageUpdated_new = true; // Mark the image as updated
            console.log('Image source updated to:', imageUrl);
            } else {
            console.error('Image element with class "upcart-trust-badge-image" not found.');
            }
        } else {
            //const imageElement = document.getElementsByClassName('upcart-trust-badge-image');
            var container_new = document.querySelector('#upCart');
            const imageElement = container_new.shadowRoot.querySelector(".upcart-trust-badge-image");
            
            if (imageElement) {
            imageElement.style = 'display:block';
            imageUpdated_new = true; // Mark the image as updated
            }
            
            console.log('No image URL found for country code:', countryCode);
        }
        })
        .catch(error => console.error('Error fetching location:', error))
        .finally(() => {
        isFetching_new = false; // Reset the flag once the fetch request completes
        });
    } else{
        var country__code = getCookie('changeCount');
        console.log(country__code);
        const imageUrl = imageUrlMap_new[country__code];

        if (imageUrl) {
            // Find the image tag with class 'upcart-trust-badge-image'
            //const imageElement = document.getElementsByClassName('upcart-trust-badge-image');
            var container_new = document.querySelector('#upCart');
            const imageElement = container_new.shadowRoot.querySelector(".upcart-trust-badge-image");
            
        if (imageElement) {
            // Update the image src based on country code
            imageElement.src = imageUrl;
            imageElement.style = 'display:block';
            imageUpdated_new = true; // Mark the image as updated
            console.log('Image source updated to:', imageUrl);
            } else {
            console.error('Image element with class "upcart-trust-badge-image" not found.');
            }
        } else {
            //const imageElement = document.getElementsByClassName('upcart-trust-badge-image');
            var container_new = document.querySelector('#upCart');
            const imageElement = container_new.shadowRoot.querySelector(".upcart-trust-badge-image");
            
            if (imageElement) {
            imageElement.style = 'display:block';
            imageUpdated_new = true; // Mark the image as updated
            }
            
            console.log('No image URL found for country code:', country__code);
        }
    }
}

// Function to check for the image element and update it
function checkAndUpdateImagenew() {

  /*if (imageUpdated_new) {
    clearInterval(intervalId_new); // Stop the interval if the image has been updated
    return;
  }*/

  //const imageElement = document.querySelector('.upcart-trust-badge-image');

  var container_new = document.querySelector('#upCart');
  const imageElement_new = container_new.shadowRoot.querySelector(".upcart-trust-badge-image");
  //console.log(imageElement1);
  if (imageElement_new) {
    //imageElement_new.style = 'display:none';
    updateTrustBadgeImagenew(); // Update image if element is found
  }
}

// Start checking for the image element every 500 milliseconds
const intervalId_new = setInterval(checkAndUpdateImagenew, 500);